// Add your custom JS here.

var swiper = new Swiper(".products-carousel", {
    spaceBetween: 30,
    slidesPerView: 3.8,
    speed: 500,
    centeredSlides: true,
    loop: true,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        500: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 2.8,
            spaceBetween: 30,
        },
        990: {
            slidesPerView: 3.8,
            spaceBetween: 30,
        }
    },
});